import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ONE_WAY_IN_BASE_ROUTE } from 'src/navigation';

import Opportunity from './pages/Opportunity';
import ActivityLog from './pages/ActivityLog';
import Services from './pages/Services';
import CompanyInfo from './pages/CompanyInfo';
import CustomerCommunication from './pages/CustomerCommunication';
import OpportunityOverview from './pages/OpportunityOverview';

const ONE_WAY_IN_DETAILS_BASE = 'details';
const ONE_WAY_IN_DETAILS_INQUIRY = 'inquiry';
const ONE_WAY_IN_DETAILS_ACTIVITY_LOG = 'activityLog';
const ONE_WAY_IN_DETAILS_NOTE = 'note';
const ONE_WAY_IN_DETAILS_SERVICES = 'services';
const ONE_WAY_IN_DETAILS_COMPANY_INFO = 'companyInfo';
const ONE_WAY_IN_CUSTOMER_COMMUNICATION = 'customerCommunication';

export const ONE_WAY_IN_DETAILS = {
  BASE: (formId: string) => `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}` as const,
  INQUIRY: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_INQUIRY}` as const,
  ACTIVITY_LOG: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_ACTIVITY_LOG}` as const,
  NOTE: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_NOTE}` as const,
  SERVICES: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_SERVICES}` as const,
  COMPANY_INFO: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_COMPANY_INFO}` as const,
  CUSTOMER_COMMUNICATION: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_CUSTOMER_COMMUNICATION}` as const,
};

const NavigateToBase: React.FC = () => <Navigate to=".." replace />;

const routes: RouteObject[] = [
  {
    path: ``,
    element: <OpportunityOverview />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_INQUIRY}`,
    element: <Opportunity />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_ACTIVITY_LOG}`,
    element: <ActivityLog />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_SERVICES}`,
    element: <Services />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_COMPANY_INFO}`,
    element: <CompanyInfo />,
  },
  {
    path: `${ONE_WAY_IN_CUSTOMER_COMMUNICATION}`,
    element: <CustomerCommunication />,
  },
  {
    path: `*`,
    element: <NavigateToBase />,
  },
];

export default routes;
